var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"sound-toggle",class:{
    'sound-toggle--active': _vm.isSoundOn,
    'home-page': _vm.$route.name == 'Home' || _vm.$route.path == '/',
  },attrs:{"type":"button","aria-label":_vm.isSoundOn ? 'Mute sound' : 'Unmute sound'},on:{"click":_vm.toggleSound}},[_c('IconSound',{attrs:{"is-muted":_vm.isSoundOn,"size":64,"color":"#FFFFFF"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }